import {
    type IntegrityStatus,
    checkModulePropsExist,
} from "~utils/moduleIntegrity";

import type { SocialButtonsDefaultProps } from "./SocialButtonsDefault";

export default function integrityCheck(
    props: SocialButtonsDefaultProps
): IntegrityStatus {
    const messages = checkModulePropsExist(props, [
        "facebookAccount",
        "twitterAccount",
        "youTubeAccount",
        "instagramAccount",
        "linkedinAccount",
    ]);

    // we require one of the accounts to be present
    // to render the module. If we have five errors,
    // all social accounts are missing and we cannot
    // render.
    if (messages.length === 5) {
        return messages;
    }

    return [];
}
